"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _loginConnector = _interopRequireDefault(require("../../login/login-connector"));
var _jumbotron = _interopRequireDefault(require("./jumbotron"));
var _jumbotronHeading = _interopRequireDefault(require("./jumbotron-heading"));
var _jumbotronLead = _interopRequireDefault(require("./jumbotron-lead"));
var _jumbotronHr = _interopRequireDefault(require("./jumbotron-hr"));
var _formGroup = _interopRequireDefault(require("./form-group"));
var _input = _interopRequireDefault(require("./input"));
var _submit = _interopRequireDefault(require("./submit"));
var _button = _interopRequireDefault(require("./button"));
var _alert = _interopRequireDefault(require("./alert"));
var _linkButton = _interopRequireDefault(require("./link-button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_jumbotronHeading.default, null, "Canoe Slalom Entries");
var _ref2 = /*#__PURE__*/_react.default.createElement(_jumbotronLead.default, null, "Sign in here to enter slalom competitions online");
var _ref3 = /*#__PURE__*/_react.default.createElement(_jumbotronHr.default, null);
var _ref4 = /*#__PURE__*/_react.default.createElement("label", null, "Email address");
var _ref5 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "danger"
}, "Sorry, we were unable to log you in. Please make sure you have entered a valid e-mail address, then try again.");
class LoginForm extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onEmailChange", value => {
      this.props.onEmailChanged(value);
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      const successUrl = this.props.successUrl || this.props.location.pathname;
      this.props.onLoginRequest(successUrl);
    });
  }
  render() {
    const successUrl = this.props.successUrl || this.props.location.pathname;
    return /*#__PURE__*/_react.default.createElement(_jumbotron.default, null, _ref, this.props.isAuthenticated ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_jumbotronLead.default, null, "You are signed in as ", /*#__PURE__*/_react.default.createElement("strong", null, this.props.user.email)), this.props.location.pathname === successUrl ? null : /*#__PURE__*/_react.default.createElement(_linkButton.default, {
      to: successUrl,
      type: "primary"
    }, "Enter Competition"), /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "link",
      onClick: this.props.onLogout
    }, "(change user)"), ' ') : this.props.emailConfirmationRequired ? /*#__PURE__*/_react.default.createElement(_jumbotronLead.default, {
      level: "primary",
      "data-test-id": "sent-login-email-message"
    }, "We have sent an e-mail to ", this.props.email, ". Please click the link in the e-mail to confirm your e-mail address.") : /*#__PURE__*/_react.default.createElement("div", null, _ref2, _ref3, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_input.default, {
      "data-test-id": "login-email-input",
      type: "email",
      value: this.props.email,
      onChange: this._onEmailChange,
      disabled: this.props.loggingIn
    })), !this.props.onCancel ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.props.onCancel
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_submit.default, {
      "data-test-id": "login-button",
      disabled: !this.props.emailIsValid,
      loading: this.props.loggingIn
    }, "Next")), !this.props.loginFailed ? null : /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: 16
      }
    }, _ref5)));
  }
}
_defineProperty(LoginForm, "propTypes", {
  successUrl: _propTypes.default.string
});
var _default = exports.default = (0, _loginConnector.default)((0, _reactRouterDom.withRouter)(LoginForm));